import {
	SYSTEM_HEADER_LEFT,
	SYSTEM_USER,
} from '@confluence/web-item-location/entry-points/webFragmentLocations.ts';
import { preloadWebItemLocation } from '@confluence/web-item-location/entry-points/preloadWebItemLocation.ts';
import { expValEquals } from '@confluence/feature-experiments';

export const preloadProfileMenu = () => {
	if (expValEquals('web_item_query_batch_system_call', 'isEnabled', true)) {
		// call using both System Header Left and System User to ensure both are preloaded together for better performance
		return preloadWebItemLocation({ location: [SYSTEM_HEADER_LEFT, SYSTEM_USER] });
	} else {
		// Fallback: preload SYSTEM_USER separately when combined optimization is disabled
		return preloadWebItemLocation({ location: SYSTEM_USER });
	}
};
